import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';

export default function AdminPage() {
  const [tab, setTab] = useState('employees');
  return (
    <div style={{ padding:'1.5rem', maxWidth:900, margin:'0 auto' }}>
      <h1 style={{ fontWeight:600, fontSize:20, marginBottom:4 }}>Admin panel</h1>
      <p style={{ color:'var(--gray-500)', fontSize:13, marginBottom:'1.25rem' }}>Manage employees and approved office locations</p>
      <div style={{ display:'flex', gap:0, borderBottom:'1px solid var(--gray-200)', marginBottom:'1.5rem' }}>
        {['employees','locations'].map(t => (
          <button key={t} onClick={() => setTab(t)} style={{
            padding:'9px 18px', background:'none', border:'none', fontWeight:500, cursor:'pointer',
            borderBottom: tab===t ? '2px solid #2563eb' : '2px solid transparent',
            color: tab===t ? '#2563eb' : 'var(--gray-500)', borderRadius:0, marginBottom:-1,
          }}>{t.charAt(0).toUpperCase()+t.slice(1)}</button>
        ))}
      </div>
      {tab === 'employees' ? <EmployeesPanel /> : <LocationsPanel />}
    </div>
  );
}

function EmployeesPanel() {
  const [employees, setEmployees] = useState([]);
  const [form, setForm] = useState({ name:'', email:'', department:'' });
  const [msg, setMsg]   = useState({ type:'', text:'' });

  useEffect(() => { load(); }, []);
  const load = () => api.getEmployees().then(setEmployees).catch(() => {});

  async function submit() {
    try {
      await api.createEmployee(form);
      setMsg({ type:'success', text:`"${form.name}" added successfully.` });
      setForm({ name:'', email:'', department:'' });
      load();
    } catch (e) { setMsg({ type:'error', text: e.message }); }
  }

  return (
    <>
      <div className="card" style={{ marginBottom:'1.5rem' }}>
        <h3 style={{ fontWeight:600, marginBottom:'1rem' }}>Add new employee</h3>
        {msg.text && <div className={`alert alert-${msg.type==='error'?'error':'success'}`} style={{ marginBottom:'1rem' }}>{msg.text}</div>}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12, marginBottom:12 }}>
          <F label="Full name"  value={form.name}       onChange={v=>setForm(f=>({...f,name:v}))}       placeholder="Hamid Al-Rashid" />
          <F label="Email"      value={form.email}      onChange={v=>setForm(f=>({...f,email:v}))}      placeholder="hamid@company.com" />
          <F label="Department" value={form.department} onChange={v=>setForm(f=>({...f,department:v}))} placeholder="Engineering" />
        </div>
        <button className="btn btn-primary" onClick={submit}>Add employee</button>
      </div>
      <div className="card" style={{ padding:0, overflow:'hidden' }}>
        <table>
          <thead><tr><th>Name</th><th>Email</th><th className="hide-mobile">Department</th><th>Biometric</th></tr></thead>
          <tbody>
            {employees.map(e => (
              <tr key={e.id}>
                <td style={{ fontWeight:500 }}>{e.name}</td>
                <td style={{ color:'var(--gray-500)', fontSize:12 }}>{e.email}</td>
                <td className="hide-mobile">{e.department}</td>
                <td><span className={`badge ${e.has_biometric?'badge-green':'badge-amber'}`}>{e.has_biometric?'✅ Registered':'⬜ Not set'}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

function LocationsPanel() {
  const [locations, setLocations] = useState([]);
  const [form, setForm] = useState({ name:'', latitude:'', longitude:'', radius_m:100 });
  const [msg, setMsg]   = useState({ type:'', text:'' });

  useEffect(() => { load(); }, []);
  const load = () => api.getLocations().then(setLocations).catch(() => {});

  async function submit() {
    try {
      await api.createLocation(form);
      setMsg({ type:'success', text:`"${form.name}" added.` });
      setForm({ name:'', latitude:'', longitude:'', radius_m:100 });
      load();
    } catch (e) { setMsg({ type:'error', text: e.message }); }
  }

  return (
    <>
      <div className="card" style={{ marginBottom:'1.5rem' }}>
        <h3 style={{ fontWeight:600, marginBottom:4 }}>Add allowed location</h3>
        <p style={{ fontSize:13, color:'var(--gray-500)', marginBottom:'1rem' }}>
          Get coordinates: open Google Maps → right-click the office → copy the numbers shown.
        </p>
        {msg.text && <div className={`alert alert-${msg.type==='error'?'error':'success'}`} style={{ marginBottom:'1rem' }}>{msg.text}</div>}
        <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1fr 1fr', gap:12, marginBottom:12 }}>
          <F label="Location name" value={form.name}      onChange={v=>setForm(f=>({...f,name:v}))}      placeholder="Riyadh HQ" />
          <F label="Latitude"      value={form.latitude}  onChange={v=>setForm(f=>({...f,latitude:v}))}  placeholder="24.7136" />
          <F label="Longitude"     value={form.longitude} onChange={v=>setForm(f=>({...f,longitude:v}))} placeholder="46.6753" />
          <F label="Radius (m)"    value={form.radius_m}  onChange={v=>setForm(f=>({...f,radius_m:v}))}  placeholder="100" type="number" />
        </div>
        <button className="btn btn-primary" onClick={submit}>Add location</button>
      </div>
      <div className="card" style={{ padding:0, overflow:'hidden' }}>
        <table>
          <thead><tr><th>Name</th><th>Latitude</th><th>Longitude</th><th>Radius</th></tr></thead>
          <tbody>
            {locations.map(l => (
              <tr key={l.id}>
                <td style={{ fontWeight:500 }}>{l.name}</td>
                <td style={{ fontFamily:'monospace', fontSize:12 }}>{l.latitude}</td>
                <td style={{ fontFamily:'monospace', fontSize:12 }}>{l.longitude}</td>
                <td>{l.radius_m} m</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

const F = ({ label, value, onChange, placeholder, type='text' }) => (
  <div>
    <div style={{ fontSize:12, fontWeight:500, color:'var(--gray-700)', marginBottom:4 }}>{label}</div>
    <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} />
  </div>
);
